// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63ee52cc","455":"dd4e74d1"}[chunkId] + ".chunk.js";
};